import React from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import ConsentPromptContent from '../ConsentPromptContent'

import Styles from './styles.scss'

import useScrollToAccept from './hooks/useScrollToAccept'


export default function Banner({ ariaLabel }) {
  const consentConfig = useConsentConfig()

  useScrollToAccept({
    isEnabled: consentConfig.enable_consent_by_scroll,
  })

  const rootClassName = classnames(Styles[`termly-${ consentConfig.display_style }`],
                                   Styles[consentConfig.size],
                                   Styles[consentConfig.position])

  return (
    <ConsentPromptContent
      ariaLabel={ ariaLabel }
      className={ rootClassName }
      role="region"
      stylesOverrides={ Styles }
    />
  )
}

Banner.propTypes = {
  ariaLabel: PropTypes.string,
}

